// extracted by mini-css-extract-plugin
export var blueCircle = "index-module--blueCircle--f7YUO";
export var consultBtn = "index-module--consultBtn--tDkm1";
export var detailContent = "index-module--detailContent--PuefH";
export var enterpriseDescription = "index-module--enterpriseDescription--bIFaw";
export var hr = "index-module--hr--rL8py";
export var number = "index-module--number--h79YA";
export var smallCircle = "index-module--smallCircle--6s1Mo";